import React from 'react';
import { Modal } from '../Modal';
import Button from '../Button/Button';
import './InfoModal.scss';

interface IErrorModalTypes {
  onOkClick?: () => void;
  onClose?: () => void;
  isOpen?: boolean;
  title?: string;
  info1?: React.ReactNode;
  info2?: React.ReactNode;
  buttonLabel?: string;
  footer?: React.JSX.Element;
  width?: string | number;
  // The primary action is running: expose it as busy instead of silently ignoring clicks.
  isBusy?: boolean;
}

export const InfoModal = ({
  onOkClick,
  onClose,
  isOpen = true,
  title,
  info1,
  info2,
  buttonLabel = 'OK',
  footer,
  width,
  isBusy = false,
}: IErrorModalTypes) => {
  const resolvedWidth = typeof width === 'number' ? `${width}px` : width || 'auto';

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="info-modal-container" style={{ width: resolvedWidth }}>
        <h3 className="info-modal-title">{title}</h3>
        <div className="info-description">
          <p>{info1}</p>
          <p>{info2}</p>
        </div>
        <Button
          label={buttonLabel}
          styleKey="dark"
          width="250px"
          onClick={onOkClick}
          isBusy={isBusy}
        />
        {footer}
      </div>
    </Modal>
  );
};
